import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';

import { setPreference } from '../../actions/preferenceActions';
import { showInfo } from '../../actions/notificationActions';

// Personal preferences panel. Each toggle dispatches setPreference and is
// persisted client-side (redux-persist). Preferences take effect wherever a
// component opts in to read them from state.preferences.
const TOGGLES = [
  {
    key: 'tablePollingEnabled',
    label: 'Auto-refresh tables',
    hint: 'Periodically re-fetch lists and tables that support polling.',
  },
  {
    key: 'showActionToasts',
    label: 'Show confirmation toasts',
    hint: 'Display a toast after preference changes and similar actions.',
  },
];

class AccountSettings extends React.Component {
  onToggle = (key) => (e) => {
    const value = e.target.checked;
    this.props.setPreference(key, value);

    if (this.props.preferences.showActionToasts) {
      this.props.showInfo('Preference saved');
    }
  };

  render() {
    const { preferences } = this.props;

    return (
      <Row>
        <Col xs={12} md={8}>
          <Form>
            {TOGGLES.map((toggle) => (
              <FormGroup check key={toggle.key} className="mb-3">
                <Label check>
                  <Input
                    type="checkbox"
                    checked={!!preferences[toggle.key]}
                    onChange={this.onToggle(toggle.key)}
                  />{' '}
                  {toggle.label}
                </Label>
                <small className="text-muted d-block">{toggle.hint}</small>
              </FormGroup>
            ))}
          </Form>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({ preferences: state.preferences });

export default connect(mapStateToProps, { setPreference, showInfo })(
  AccountSettings
);
